import { Controller } from 'stimulus'
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper/core';
import throttle from '../utils/throttle'

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);

export default class extends Controller {
  static targets = ['container', 'next', 'prev', 'nav', 'mobileTitles']

  initialize() {
    this._handleScroll = throttle(this.handleScroll.bind(this), 100)
  }

  setNavActive(index) {
    this._navSlides.forEach(slide => slide.classList.remove('active'))
    this._navSlides[index].classList.add('active')

    this._mobileTitles.forEach(slide => slide.classList.remove('active'))
    this._mobileTitles[index].classList.add('active')
  }

  goTo(e) {
    const index = Array.from(e.currentTarget.parentElement.children).indexOf(e.currentTarget)
    this._swiper.slideTo(index)
  }

  restartCurrentSlide() {
    const currentIndex = this._swiper.realIndex
    this._swiper.slideReset()
    this._navSlides[currentIndex].classList.remove('active')
    this._mobileTitles[currentIndex].classList.remove('active')
    setTimeout(() => {
      this.setNavActive(currentIndex)
    }, 1)
  }

  handleScroll() {
    const position = this.element.getBoundingClientRect()
    const inView = position.top < window.innerHeight && position.bottom > 0

    if (inView) {
      if (!this._swiper.autoplay.paused) return
      this._swiper.autoplay.run()
      this._swiper.autoplay.paused = false
      this.restartCurrentSlide()
    } else {
      if (this._swiper.autoplay.paused) return
      this._swiper.autoplay.pause()
    }
  }

  unbindScroll() {
    window.removeEventListener('scroll', this._handleScroll)
  }

  connect() {
    this._navSlides = Array.from(this.navTarget.children)
    this._mobileTitles = Array.from(this.mobileTitlesTarget.children)
    this._swiper = new Swiper(this.containerTarget, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: { nextEl: this.nextTarget, prevEl: this.prevTarget },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      swipeHandler: this.mobileTitlesTarget,
      on: {
        slideChange: () => this.setNavActive(this._swiper.realIndex),
        init: () => this.setNavActive(0),
      },
    })

    window.addEventListener('scroll', this._handleScroll)
    this.handleScroll()
  }

  disconnect() {
    this.unbindScroll()
  }
}
